var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAthleteWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1711 6.13379C3.1711 6.13379 2.31886 6.77522 1.18443 7.71749C0.0499904 8.65977 0.439423 10.1072 1.52306 11.3504C3.00178 13.0419 4.25474 13.9728 7.29119 14.5291C9.3343 14.9038 10.1075 14.9435 11.4903 16.0106L12.3425 16.7883C13.0706 17.6681 15.2548 19.144 16.6319 19.144H22.0896C23.7377 19.144 24.7254 17.9633 25.318 17.0267C25.5381 16.6805 25.9162 15.9766 26.1702 15.2443",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06211 6.52009C3.12419 6.00922 3.37253 5.33373 3.63215 4.94206C3.63215 4.94206 4.15773 3.71895 4.66781 3.049C5.34885 2.15451 6.83227 1.15593 6.83227 1.15593C7.67887 0.38395 7.97799 0.452066 9.01084 0.576946C10.0493 0.701826 8.73429 1.67816 10.3485 3.0121C11.9626 4.34604 13.5768 3.59677 14.429 3.27889C15.3829 2.92696 15.9021 3.04048 16.3423 4.09061C16.9067 5.44158 20.4568 10.7376 21.4219 11.9978C22.7765 12.3327 25.1638 12.8435 26.129 13.2295C26.8965 13.5361 26.3434 15.3355 25.6549 16.0166C24.5712 16.8851 22.3814 16.8624 19.6892 16.8624C16.997 16.8624 14.5984 15.9826 12.8149 13.8028C11.0314 11.6231 9.16323 11.9751 7.2725 11.2882C5.92924 10.8001 2.80249 8.57493 3.06211 6.52009Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9977 4.37402L14.6113 6.07693",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1247 6.06641L15.7383 7.76931",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2575 7.78125L16.8711 9.48416",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3844 9.47363L17.998 11.1765",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthleteWhiteIcon);
export default __webpack_public_path__ + "static/media/athlete-white-icon.70f5d8ce3d51b72179fd02218a87fd44.svg";
export { ForwardRef as ReactComponent };